<template>
  <div>

    <div v-if="sharayet == false" class="login-box">
      <h2 style="font-weight: bold;">روبو - هوش مصنوعی فارسی</h2>
      <h2 style="font-weight: bold;">ورود | ثبت نام</h2>
      <h5 style="color: white;white-space: pre-wrap;line-height: 20px;">{{ this.showText }}</h5>

      <form>
        <div v-if="showCode == 1" class="user-box" style="margin-top:20px;">
          <input v-on:keydown.enter.prevent="sendVerificationCode()" v-model="mobile" enterkeyhint="done"
            style="text-align: right;" type="tel" maxlength="11" pattern="[0-9]*" inputmode="numeric" required>
          <label>شماره موبایل</label>
        </div>
        <div v-if="showCode == 2" class="verification-code-container">
            <label class="verification-label">کد تایید</label>
            <div class="verification-code-boxes">
              <input
                v-for="(digit, index) in codeDigits"
                :key="index"
                v-model="codeDigits[index]"
                @input="handleCodeInput(index, $event)"
                @keydown="handleCodeKeydown(index, $event)"
                @paste="handleCodePaste($event)"
                @focus="handleCodeFocus($event)"
                type="tel"
                maxlength="1"
                pattern="[0-9]*"
                inputmode="numeric"
                class="code-input"
                :class="{ 'filled': codeDigits[index] }"
                ref="codeInputs"
              />
            </div>
            <div class="resend-code-container">
              <span class="resend-text">کد را دریافت نکردید؟</span>
              <button 
                type="button" 
                class="resend-button" 
                @click="resendCode()"
                :disabled="resendCooldown > 0"
              >
                {{ resendCooldown > 0 ? `ارسال مجدد (${resendCooldown}ثانیه)` : 'ارسال مجدد' }}
              </button>
            </div>
            </div>
        <div v-if="showReferral" class="form-group form-check" style="margin-top:20px;">
          <input v-model="showReferralBox" type="checkbox" id="referralCheck" class="form-check-input">
          <label class="form-check-label" for="referralCheck" style="font-size:12px;color: white;">در صورتی که کد معرف
            دارید این گزینه را فعال کنید (نیازی به پر کردن نیست)</label>
        </div>
        <br />
        <div v-if="showReferralBox" class="user-box" style="margin-top:10px;margin-bottom:20px;">
          <input v-on:keydown.enter.prevent="sendVerificationCode()" v-model="referral" enterkeyhint="done"
            style="text-align: right;" type="text" maxlength="6" name="" required>
          <label>کد معرف</label>
        </div>
        <div v-if="showCode == 0"
          @click="showCode = 1; showText = 'لطفا شماره موبایل خود را وارد کنید تا کد تایید برایتان ارسال شود'"
          style="text-align:center;padding:10px;background-color:#6153cc;color:white;font-size:17px;font-weight: bold;border-radius: 10px;margin-top:-20px;cursor: pointer;">
          ورود با شماره موبایل
        </div>
        <div v-if="showCode == 1" v-on:keydown.enter.prevent="sendVerificationCode()" @click="sendVerificationCode()"
          style="text-align:center;padding:10px;background-color:#6153cc;color:white;font-size:17px;font-weight: bold;border-radius: 10px;cursor: pointer;">
          ارسال کد تایید
        </div>
        <div v-if="showCode == 2" v-on:keydown.enter.prevent="sendVerificationCode()" @click="sendVerificationCode()"
          style="text-align:center;padding:10px;background-color:#6153cc;color:white;font-size:17px;font-weight: bold;border-radius: 10px;cursor: pointer;">
          تایید
        </div>
      </form>
      <br>
      <!-- <div v-if="showCode == 0" style="text-align: center;margin-top:-20px">
        <hr>
        <GoogleLogin v-if="!isApplication" :callback="login">
        </GoogleLogin>
        <div v-else @click="signInGoogle"
          style="padding:10px;background-color: rgb(245, 47, 47);color:white;font-size:17px;font-weight: bold;border-radius: 10px;">
          ورود با گوگل
        </div>
      </div> 
      <br>
      -->
      <div style="font-size: small;text-align: center;color:rgb(157 157 157)"> ورود شما به معنای پذیرش <span
          style="cursor: pointer;text-decoration: underline;color:rgb(97 85 189);" @click="this.sharayet = true">شرایط و
          قوانین</span> روبو است </div>
    </div>
    <div style="height: 80%;" v-else class="login-box">
      <h2>شرایط استفاده | حریم خصوصی</h2>
      <p style="font-size:small;float:left;height:80%;
overflow-y: auto;color:rgb(202, 202, 202);word-wrap: break-word;word-break: break-word;white-space: pre-line;">
        <span style="color:rgb(248, 248, 248);font-weight:800;font-size: larger;">قوانین و مقررات</span>
        <br>
        <br>
        کاربر گرامی ضمن سپاس از انتخاب سرویس روبو، لازم است پیش از استفاده از این محصول، نکات مورد اهمیت استفاده از سایت
        و اپلیکیشن را به دقت ملاحظه فرمائید. روبو محصول شرکت روبو و ساخته شده در ایران و تابع قوانین جمهوری اسلامی ایران
        است. روبو با تلاش مهندسین ایرانی ساخته شده است که تشکیل شده از ماژول های مختلفی مانند: موتور هوش مصنوعی است.
        <br>
        <br>
        <span style="color:rgb(248, 248, 248);font-weight:800;font-size: larger;">تعاریف و اصطلاحات</span>
        <br>
        <br>روبو: خدمات نرم افزاری بر بستر اینترنت که توسط شرکت روبو به منظور پرسش و پاسخ کاربران از دستیار هوش مصنوعی و
        دریافت پاسخ از سرویس های مختلف ارائه می شود.
        <br>اپلیکیشن: نرم افزار متعلق به شرکت روبو که به منظور استفاده از خدمات روبو، حق استفاده موقت از آن برابر با
        شرایط مندرج در قرارداد خصوصی و سند حاضر به کاربران یا طرف های تجاری شرکت اعطا می شود.
        <br>کاربر: شخصی حقیقی یا حقوقی است اعم از کاربر، سرویس های ثالث که برابر شرایط و قوانین حاضر از هر طریقی به
        اپلیکیشن متصل و از خدمات روبو بهره مند می شود.
        <br>طرف تجاری: اشخاص حقیقی و حقوقی که برابر قرارداد خصوصی، حق بهره برداری موقت از اپلیکیشن روبو را با نام تجاری
        خود یا مشترک با شرکت روبو دارند.
        <br>حساب کاربری: حسابی است که اشخاص برای اسفاده از خدمات روبو در اپلیکیشن و سایت ایجاد کرده اند.
        <br>اطلاعات محرمانه: اطلاعاتی که توسط کاربران در روبو قرارداده می شود. اعم از اطلاعاتی که به صورت خودکار و در
        نتیجه بهره برداری از خدمات روبو توسط شرکت با طرف های تجاری تولید یا در اختیار شرکت قرارداده می شود.

        <br><br><span style="color:rgb(248, 248, 248);font-weight:800;font-size: larger;">شرایط و قوانین استفاده از
          روبو</span>
        <br>
        <br>روبو خدمات خود را طبق این قوانین در اختیار شما می گذارد و شما به عنوان کاربر، خود را ملزم به رعایت مفاد
        مذکور در این توافق می کنید. ورود کاربران به روبو هنگام استفاده از پروفایل شخصی خدمات ارائه شده توسط روبو مانند
        هوش مصنوعی به معنای آگاه بودن و پذیرفتن قوانین و همچنین نحوه استفاده از سرویس و خدمات روبو است. لازم به ذکر است
        شرایط و قوانین مندرج، جایگزین کلیه توافق های قبلی محسوب می شود.
        <br>دقت فرمایید کلیه اصول و رویه های روبو منطبق با قوانین جمهوری اسلامی ایران، قانون تجارت الکترونیک و قانون
        حمایت از حقوق مصرف کننده است و متعاقبا کاربر نیز موظف به رعایت قوانین مرتبط با کاربر است. درصورتی که در قوانین
        مندرج، رویه ها و سرویس های روبو تغییرانی در آینده ایجاد شود، از طریق درگاه های ارتباطی روبو به روزرسانی می شود و
        شما توافق می کنید که استفاده مستمر شما از اپلیکیشن به معنی پذیرش هرگونه تغییر است.
        <br>هسته مرکزی این دستیار، از سرویس های مختلفی مانند سرویس های ChatGPT که پردازش و پاسخ به سوالات از طریق آن
        انجام می گیرد.
        <br><br>
        <span style="color:rgb(248, 248, 248);font-weight:800;font-size: larger;">
          سیاست های رعایت حریم شخصی</span><br>
        <br>روبو به اطلاعات خصوصی اشخاصی که از اپلیکیشن و سایت استفاده می کنند احترام گذاشته و از آن ها محافظت می کند؛
        همچنین متعهد می شود در حد توان از حریم شخصی شما دفاع کند و در این راستا، تکنولوژی مورد نیاز برای هرچه مطمئن تر و
        امن تر شدن استفاده شما از اپلیکیشن را، توسعه دهد.
        <br>با توجه به اینکه پاسخ برخی سوالات از طریق سرویس ربات گفتگوی ChatGPT ایجاد می شود، روبو هیچگونه مسئولیتی در
        خصوص محتوای سوالات و پاسخ های این سرویس ندارد. همچنین هرگونه سوء استفاده از این محصول بر عهده کاربر است.
        <br>کاربر متعهد می شود جهت استفاده از اپلیکیشن و سایت روبو، شماره تلفن همراه ثبت شده به نام خود او باشد. همچنین
        از این اپلیکیشن برای اهداف غیر مندرج استفاده نکند.
        <br>صدا های ضبط شده به هیچ عنوان در سرور های روبو ذخیره نمیشود
        <br>عکس های گرفته شده در روبو ویژن به هیچ عنوان در سرور های روبو ذخیره نمیشود

      </p>
      <button @click="this.sharayet = false" type="submit" class="text-white btn w-100"
        style="background-color: #7d70e2;">موافقم</button>

    </div>
  </div>
</template>
<script>
import router from '@/router';
import axios from 'axios';
import { notify } from "@kyvg/vue3-notification";
import { googleAuthCodeLogin } from "vue3-google-login"

export default {
  data() {
    return {
      showCode: 0,
      mobile: '',
      code: '',
      send: false,
      sharayet: false,
      referral: '',
      googleAuth: '',
      showText: 'برای استفاده از امکانات روبو، لطفا یکی را برای ادامه انتخاب کنید.',
      showReferral: false,
      showReferralBox: false,
      buttonText: 'ورود',
      s: 49918617,
      t: null,
      isApplication: navigator.userAgent.match(/ir.roboo.pwa/i) ? true : false,
      timeOutSignInGoogle: false,
      resendTimer: null,
      codeDigits: ['', '', '', '', '', ''],
      resendCooldown: 0,


    }
  },

  methods: {
    inputCodeChange() {
      if (this.code.length > 5)
        this.sendVerificationCode();
    },
    newlogin() {
      googleAuthCodeLogin().then((response) => {
        console.log("Handle the response", response.credential)
      })
    },
    login(response) {
      if (response.credential)
        this.loginWithGoogle(response.credential)
      else {
        notify({
          title: "خطا",
          text: "مشکلی در فرایند ورود به وجود امده\n با پشتیبانی تماس بگیرید",
          type: "error"
        });
      }
    },
    setCode(tok) {
      console.log("Here,"+tok);
      const codeStr = tok.toString().slice(0, 6);
      for (let i = 0; i < 6; i++) {
        this.codeDigits[i] = codeStr[i] || '';
      }
      this.code = codeStr;
      this.sendVerificationCode();
    },
    handleCodeInput(index, event) {
      const value = event.target.value.replace(/[^0-9]/g, '');
      if (value) {
        this.codeDigits[index] = value;
        // Move to next input
        if (index < 5) {
          this.$nextTick(() => {
            this.$refs.codeInputs[index + 1]?.focus();
          });
        }
      } else {
        this.codeDigits[index] = '';
      }
      this.updateCodeFromDigits();
    },
    handleCodeKeydown(index, event) {
      // Handle backspace
      if (event.key === 'Backspace' && !this.codeDigits[index] && index > 0) {
        this.$refs.codeInputs[index - 1]?.focus();
      }
      // Handle arrow keys
      if (event.key === 'ArrowLeft' && index > 0) {
        this.$refs.codeInputs[index - 1]?.focus();
      }
      if (event.key === 'ArrowRight' && index < 5) {
        this.$refs.codeInputs[index + 1]?.focus();
      }
    },
    handleCodePaste(event) {
      event.preventDefault();
      const pastedData = event.clipboardData.getData('text').replace(/[^0-9]/g, '').slice(0, 6);
      for (let i = 0; i < 6; i++) {
        this.codeDigits[i] = pastedData[i] || '';
      }
      this.updateCodeFromDigits();
      // Focus on the last filled input or the last input
      const lastFilledIndex = Math.min(pastedData.length - 1, 5);
      this.$nextTick(() => {
        this.$refs.codeInputs[lastFilledIndex]?.focus();
      });
    },
    handleCodeFocus(event) {
      // Select all text when focusing
      event.target.select();
    },
    updateCodeFromDigits() {
      this.code = this.codeDigits.join('');
      if (this.code.length === 6) {
        this.$nextTick(() => {
          this.sendVerificationCode();
        });
      }
    },
    resendCode() {
      if (this.resendCooldown > 0) return;
      
      // Clear existing timer
      if (this.resendTimer) {
        clearInterval(this.resendTimer);
        this.resendTimer = null;
      }
      
      // Reset code inputs
      this.codeDigits = ['', '', '', '', '', ''];
      this.code = '';
      this.send = false;
      
      // Resend the code
      let loading = this.$loading.show({
        isFullPage: true,
        canCancel: false,
        loader: "bars",
        color: "#3e5ada",
        height: "100",
        width: "90",
      });
      
      if (this.isApplication == true)
        // eslint-disable-next-line
        Android.SmsReceiver();
      
      axios
        .post("https://api.roboo.ir/api/Users/SendVerificationCode?PhoneNumber=" + this.mobile+"&code="+this.t)
        .then(response => {
          loading.hide();
          if (response.data == 1) {
            this.startResendCooldown();
            notify({
              title: "موفق",
              text: "کد تایید مجدداً برای شماره " + this.mobile + " پیامک شد",
              type: "success"
            });
            this.$nextTick(() => {
              this.$refs.codeInputs?.[0]?.focus();
            });
          }
          else if (response.data == 2) {
            notify({
              title: "خطا",
              text: "کد های ارسال شده بیش از حد مجاز است.\nلطفا کمی صبر کنید.",
              type: "error"
            });
          }
          else {
            notify({
              title: "خطا",
              text: "خطایی در ارسال مجدد کد رخ داد",
              type: "error"
            });
          }
        })
        .catch(() => {
          loading.hide();
          notify({
            title: "خطا",
            text: "خطایی در ارسال مجدد کد رخ داد",
            type: "error"
          });
        });
    },
    startResendCooldown() {
      // Clear existing timer if any
      if (this.resendTimer) {
        clearInterval(this.resendTimer);
        this.resendTimer = null;
      }
      
      this.resendCooldown = 60;
      this.resendTimer = setInterval(() => {
        this.resendCooldown--;
        if (this.resendCooldown <= 0) {
          clearInterval(this.resendTimer);
          this.resendTimer = null;
        }
      }, 1000);
    },
    signInGoogle() {
      if (this.timeOutSignInGoogle == false) {
        this.timeOutSignInGoogle = true;
        // eslint-disable-next-line
        Android.SignInGoogle()
        setTimeout(() => {
          this.timeOutSignInGoogle = false;
        }, 5000)
      }
    },
    loginWithGoogle(tok) {
      let json = {
        token: tok.toString(),
        referral: ""
      }

      axios.post("https://api.roboo.ir/api/users/CheckGoogleAccount", json)
        .then(response => {
          this.showText = response.data;

          if (response.data.status == 0) {

            this.googleAuth = tok;
            //success
            if (response.data.isfirsttime == true) {
              localStorage.setItem("firsttime", 'true')
              localStorage.setItem("googleAccount", this.googleAuth)
            }
            localStorage.setItem("token", response.data.token)
            this.$emit("getuserData");
            router.push('/');
          }
          else if (response.data.status == 1) {
            notify({
              title: "خطا",
              text: "مشکلی در فرایند ورود به وجود امده\n با پشتیبانی تماس بگیرید",
              type: "error"
            });
            //error
          }
          else {
            notify({
              title: "خطا",
              text: "مشکلی در فرایند ورود به وجود امده\n با پشتیبانی تماس بگیرید",
              type: "error"
            });
            //error
          }
        })
        .catch(() => {
        })
    },
    showPoshtibani() {
      window.open(
        "https://www.goftino.com/c/de2QR2", "_blank");
    },
    sendVerificationCode() {
      if (this.mobile == "") {
        notify({
          title: "خطا",
          text: "شماره موبایل خالی است",
          type: "error"
        });
        return;
      }

      let loading = this.$loading.show({
        // Optional parameters
        isFullPage: true,
        canCancel: false,
        loader: "bars",
        color: "#3e5ada",
        height: "100",
        width: "90",
      });
      if (this.buttonText == "ورود") {
        if (this.send == false) {
          this.send = true;
          
          if (this.isApplication == true)
            // eslint-disable-next-line
            Android.SmsReceiver();
          axios
            .post("https://api.roboo.ir/api/Users/SendVerificationCode?PhoneNumber=" + this.mobile+"&code="+this.t)
            .then(response => {
              loading.hide();
              if (response.data == 1) {
                //success
                this.showText = "کد پیامک‌ شده به شماره «" + this.mobile + "» را وارد کنید.";
                this.showCode = 2;
                this.buttonText = "تایید";
                this.codeDigits = ['', '', '', '', '', ''];
                this.code = '';
                this.startResendCooldown();
                this.$nextTick(() => {
                  this.$refs.codeInputs?.[0]?.focus();
                });
                notify({
                  title: "موفق",
                  text: "کد تایید برای شماره " + this.mobile + " پیامک شد",
                  type: "success"
                });
              }
              else if (response.data == 2) {
                this.send = false;

                notify({
                  title: "خطا",
                  text: "کد های ارسال شده بیش از حد مجاز است.\nلطفا کمی صبر کنید.",
                  type: "error"
                });
              }
              else if (response.data == 3) {
                notify({
                  title: "خطا",
                  text: "لطفا فیلترشکن خود را خاموش کنیم و مجدد امتحان کنید",
                  type: "error"
                });
              }
              else {
                this.send = false;
                notify({
                  title: "خطا",
                  text: "شماره موبایل صحیح نمی باشد",
                  type: "error"
                });
              }
            })
            .catch(() => {
              this.send = false;
              loading.hide();
            })
        }
      }
      else {
        if (this.code == "") {
          notify({
            title: "خطا",
            text: "کد تایید خالی است",
            type: "error"
          });
          loading.hide();
          return;
        }
        axios
          .post("https://api.roboo.ir/api/Users/CheckVerificationCode?PhoneNumber=" + this.mobile + "&Code=" + this.code + "&Referral=" + this.referral)
          .then(response => {
            loading.hide();
            if (response.data.status == 0) {
              //success
              if (response.data.isfirsttime == true)
                localStorage.setItem("firsttime", 'true')

              localStorage.setItem("token", response.data.token)
              const config = { headers: { 'Content-Type': 'application/json' } };
              // eslint-disable-next-line
      axios.post("https://api.roboo.ir/api/Users/UserDate", localStorage.getItem("token"), config).then(response => {
              this.$emit("getuserData");
              router.push('/');
            });
            }
            else if (response.data.status == 1) {
              notify({
                title: "خطا",
                text: "کد وارد شده اشتباه است",
                type: "error"
              });
              //error
            }
            else if (response.data.status == 3) {
              notify({
                title: "خطا",
                text: "دفعات وارد شده بیش از حد مجاز است.\nلطفا صبر کنید.",
                type: "error"
              });
              //error
            }
            else {
              notify({
                title: "خطا",
                text: "خطایی رخ داده",
                type: "error"
              });
              //error
            }
          })
          .catch(() => {
            loading.hide();
          })
      }

    }
  },
  mounted() {// eslint-disable-next-line
    var that = this;
    this.t = (1 + Math.floor(Math.random() * this.s)) * this.s;
    window.ramingoogle = function (tok) {
      that.loginWithGoogle(tok)
    }
    window.ramincode = function (tok) {
      that.setCode(tok)
    }

  },
  beforeUnmount() {
    if (this.resendTimer) {
      clearInterval(this.resendTimer);
    }
  },
}
</script>
<style>
.notification-title {
  text-align: right;
}

.notification-content {
  text-align: right;
}

.subtitle {
  color: #eee;
  font-family: sans-serif;
  font-size: 16px;
  font-weight: 600;
  margin-top: 10px;
}

.input-container {
  height: 50px;
  position: relative;
  width: 100%;
}

.ic1 {
  margin-top: 40px;
}

.ic2 {
  margin-top: 30px;
}

.input {
  background-color: #303245;
  border-radius: 12px;
  border: 0;
  box-sizing: border-box;
  color: #eee;
  font-size: 18px;
  height: 100%;
  outline: 0;
  padding: 4px 20px 0;
  width: 100%;
}

.cut {
  background-color: #15172b;
  border-radius: 10px;
  height: 20px;
  left: 20px;
  position: absolute;
  top: -20px;
  transform: translateY(0);
  transition: transform 200ms;
  width: 76px;
}

.cut-short {
  width: 50px;
}

.input:focus~.cut,
.input:not(:placeholder-shown)~.cut {
  transform: translateY(8px);
}

.placeholder {
  color: #65657b;
  font-family: sans-serif;
  left: 20px;
  line-height: 14px;
  pointer-events: none;
  position: absolute;
  transform-origin: 0 50%;
  transition: transform 200ms, color 200ms;
  top: 20px;
}

.form1 {
  border-radius: 20px;
  box-sizing: border-box;
  padding: 20px;

}

/* Verification Code Styles */
.verification-code-container {
  margin-top: 25px;
  width: 100%;
}
.verification-label {
  display: block;
  margin-bottom: 15px;
  color: white;
  font-size: 0.95rem;
  font-weight: 600;
  text-align: center;
}
.verification-code-boxes {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: clamp(6px, 2vw, 12px);
  margin-bottom: 20px;
  direction: ltr;
  flex-wrap: wrap;
  padding: 0 10px;
}
.code-input {
  width: clamp(40px, 12vw, 55px);
  height: clamp(50px, 15vw, 65px);
  min-width: 40px;
  min-height: 50px;
  text-align: center;
  font-size: clamp(18px, 5vw, 26px);
  font-weight: bold;
  color: #333;
  background: #f8f9fa;
  border: 2px solid #e9ecef;
  border-radius: 12px;
  outline: none;
  transition: all 0.3s ease;
  font-family: 'IRANSansWeb', sans-serif;
  flex: 0 0 auto;
}
.code-input:focus {
  border-color: #6153cc;
  background: #fff;
  box-shadow: 0 0 0 4px rgba(81, 68, 255, 0.1);
  transform: scale(1.05);
}
.code-input.filled {
  border-color: #28a745;
  background: #f0fff4;
}

/* Responsive adjustments for verification code */
@media (max-width: 480px) {
  .verification-code-boxes {
    gap: 8px;
    padding: 0 5px;
  }
  .code-input {
    width: 42px;
    height: 52px;
    font-size: 20px;
  }
}

@media (max-width: 360px) {
  .verification-code-boxes {
    gap: 6px;
    padding: 0;
  }
  .code-input {
    width: 38px;
    height: 48px;
    font-size: 18px;
  }
}

@media (min-width: 768px) {
  .verification-code-boxes {
    gap: 12px;
  }
  .code-input {
    width: 55px;
    height: 65px;
    font-size: 26px;
  }
}
.resend-code-container {
  text-align: center;
  margin-top: 20px;
  padding-top: 15px;
  border-top: 1px solid #e9ecef;
}
.resend-text {
  display: block;
  color: #6c757d;
  font-size: 0.85rem;
  margin-bottom: 8px;
}
.resend-button {
  background: none;
  border: none;
  color: #6153cc;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  padding: 5px 10px;
  border-radius: 6px;
  transition: all 0.3s ease;
  font-family: 'IRANSansWeb', sans-serif;
}
.resend-button:hover:not(:disabled) {
  background: rgba(255, 68, 88, 0.1);
  transform: translateY(-1px);
}
.resend-button:disabled {
  color: #adb5bd;
  cursor: not-allowed;
}
.input:focus~.placeholder,
.input:not(:placeholder-shown)~.placeholder {
  transform: translateY(-30px) translateX(10px) scale(0.75);
}

.input:not(:placeholder-shown)~.placeholder {
  color: #808097;
}

.input:focus~.placeholder {
  color: #6153cc;
}

@font-face {
  font-family: IRANSansWeb;
  src: url('../assets/IRANSansWebBold.woff2') format("woff2");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: IRANSansWeb;
  src: url('../assets/IRANSansWebBold.woff2') format("woff2");
  font-weight: bold;
  font-style: normal;
}

html {
  height: 100%;

}

body {
  margin: 0;
  padding: 0;
  font-family: IRANSansWeb;
  background-color: #212529;
}

@media(min-width:768px) {
  .login-box {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 30vw;
    padding: 40px;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    border-radius: 10px;

  }
}

@media(max-width:767px) {
  .login-box {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 95vw;
    padding: 40px;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    border-radius: 10px;

  }
}


.login-box h2 {
  margin: 0 0 30px;
  padding: 0;
  color: #fff;
  text-align: center;
  font-size: 1.2rem;
}

.login-box h5 {
  margin: 0 0 20px;
  padding: 0;
  color: #fff;
  text-align: center;
  font-size: 0.83rem;
}

.login-box .user-box {
  position: relative;
  background-color: #3b3c3f;
  border-radius: 5px;
}

.login-box .user-box input {
  width: 100%;
  padding: 10px;
  font-size: 16px;
  color: #ffffff;
  border: none;
  outline: none;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.login-box .user-box label {
  position: absolute;
  top: 0;
  right: 0;
  padding: 10px;
  font-size: 16px;
  color: #fff;
  pointer-events: none;
  transition: .5s;
}

.login-box .user-box input:focus~label,
.login-box .user-box input:valid~label,
.login-box .user-box input:not(:placeholder-shown) label {
  top: -35px;
  right: 0;
  color: #7d70e2;
  font-size: 13px;
  margin-right: -7px;

}

.login-box form a {
  position: relative;
  display: block;
  padding: 10px 20px;
  color: #7d70e2 !important;
  font-size: 16px;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
  overflow: hidden;
  transition: .5s;
  margin-top: 10px;
  letter-spacing: 4px
}

.login-box a:hover {
  color: #fff;
  border-radius: 5px;
  box-shadow: 0 0 5px #7d70e2,
    0 0 25px #7d70e2,
    0 0 50px #7d70e2,
    0 0 100px #7d70e2;
}

.login-box a span {
  position: absolute;
  display: block;
}

.login-box a span:nth-child(1) {
  top: 0;
  left: -100%;
  width: 100%;
  height: 2px;
  background: linear-gradient(90deg, transparent, #7d70e2);
  animation: btn-anim1 1s linear infinite;
}

@keyframes btn-anim1 {
  0% {
    left: -100%;
  }

  50%,
  100% {
    left: 100%;
  }
}

.login-box a span:nth-child(2) {
  top: -100%;
  right: 0;
  width: 2px;
  height: 100%;
  background: linear-gradient(180deg, transparent, #7d70e2);
  animation: btn-anim2 1s linear infinite;
  animation-delay: .25s
}

@keyframes btn-anim2 {
  0% {
    top: -100%;
  }

  50%,
  100% {
    top: 100%;
  }
}

.login-box a span:nth-child(3) {
  bottom: 0;
  right: -100%;
  width: 100%;
  height: 2px;
  background: linear-gradient(270deg, transparent, #7d70e2);
  animation: btn-anim3 1s linear infinite;
  animation-delay: .5s
}

@keyframes btn-anim3 {
  0% {
    right: -100%;
  }

  50%,
  100% {
    right: 100%;
  }
}

.login-box a span:nth-child(4) {
  bottom: -100%;
  left: 0;
  width: 2px;
  height: 100%;
  background: linear-gradient(360deg, transparent, #7d70e2);
  animation: btn-anim4 1s linear infinite;
  animation-delay: .75s
}

@keyframes btn-anim4 {
  0% {
    bottom: -100%;
  }

  50%,
  100% {
    bottom: 100%;
  }
}
</style>